// extracted by mini-css-extract-plugin
module.exports = {"webhookList":"style_webhookList__1oQdB","flex":"style_flex__3Diz9","iconMargin":"style_iconMargin__1Dta1"};